"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeApnsSendIntegrationConfig = void 0;
var send_integration_configuration_1 = require("./send-integration-configuration");
var class_validator_1 = require("class-validator");
var is_not_empty_string_1 = require("../../class-validators/is-not-empty-string");
var send_integration_private_key_type_enum_1 = require("../../enums/send-integration-private-key-type.enum");
var native_apns_send_integration_config_builder_1 = require("../../builders/native-apns-send-integration-config-builder");
var apns_environment_1 = require("../../enums/apns-environment");
var class_transformer_1 = require("class-transformer");
var case_insensitive_ingest_1 = require("../../class-transformers/case-insensitive-ingest");
var hydrateBuilderFromKwArgs = function (config) {
    return NativeApnsSendIntegrationConfig.Builder.setIsActive(config.isActive)
        .setPrivateKeyType(config.privateKeyType)
        .setAppBundleId(config.appBundleId)
        .setTeamId(config.teamId)
        .setKeyId(config.keyId)
        .setPrivateKeyFileUrl(config.privateKeyFileUrl)
        .setPrivateKeyPassPhrase(config.privateKeyPassPhrase)
        .setExpiration(config.expiration)
        .setApnsEnvironment(config.apnsEnvironment)
        .setAdditionalPermissions(config.additionalPermissions);
};
var NativeApnsSendIntegrationConfig = (function (_super) {
    __extends(NativeApnsSendIntegrationConfig, _super);
    function NativeApnsSendIntegrationConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NativeApnsSendIntegrationConfig, "Builder", {
        get: function () {
            return new native_apns_send_integration_config_builder_1.NativeApnsSendIntegrationConfigBuilder();
        },
        enumerable: false,
        configurable: true
    });
    NativeApnsSendIntegrationConfig.buildActiveP8Configuration = function (config) {
        return hydrateBuilderFromKwArgs(__assign(__assign({}, config), { isActive: true, privateKeyType: send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P8 })).build({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P8] });
    };
    NativeApnsSendIntegrationConfig.buildActiveP12Configuration = function (config) {
        return hydrateBuilderFromKwArgs(__assign(__assign({}, config), { isActive: true, privateKeyType: send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P12 })).build({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P12] });
    };
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'additional_permissions' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.Min)(0),
        (0, class_validator_1.ValidateIf)(function (dto) { return dto.isActive; }),
        (0, class_validator_1.IsInt)({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P8, send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P12] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Number)
    ], NativeApnsSendIntegrationConfig.prototype, "additionalPermissions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'apns_environment' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P8, send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P12] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeApnsSendIntegrationConfig.prototype, "apnsEnvironment", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'app_bundle_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P12] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeApnsSendIntegrationConfig.prototype, "appBundleId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'private_key_file_url' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P8, send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P12] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeApnsSendIntegrationConfig.prototype, "privateKeyFileUrl", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'private_key_type' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsEnum)(send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType, {
            groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P8, send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P12],
        }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeApnsSendIntegrationConfig.prototype, "privateKeyType", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'private_key_pass_phrase' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P12] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeApnsSendIntegrationConfig.prototype, "privateKeyPassPhrase", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P12] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeApnsSendIntegrationConfig.prototype, "expiration", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'team_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P8] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeApnsSendIntegrationConfig.prototype, "teamId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'key_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)({ groups: [send_integration_private_key_type_enum_1.SendIntegrationPrivateKeyType.P8] }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", String)
    ], NativeApnsSendIntegrationConfig.prototype, "keyId", void 0);
    return NativeApnsSendIntegrationConfig;
}(send_integration_configuration_1.SendIntegrationConfiguration));
exports.NativeApnsSendIntegrationConfig = NativeApnsSendIntegrationConfig;
//# sourceMappingURL=native-apns-send-integration-config.js.map